export default __webpack_public_path__ + "static/media/Project-1.6a1bbc3b.jpg";